import {Base64} from 'helpers';

export function goalType(type) {
  return {
    id: type.serverId,
    name: Base64.decode(type.name),
    note: type.note,
  }
}
